import { createSelector } from "reselect";
import { selectPrepJob } from "./selectPrepJob";
import { getConsolidatedPrepInstructionFromPrepJob } from "prep/util/getConsolidatedPrepInstructionFromPrepJob";

export const selectConsolidatedPrepInstructions = createSelector(selectPrepJob, (prepJob) => {
  return getConsolidatedPrepInstructionFromPrepJob(prepJob);
});
